import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function notificarBaixaLote(promise) {
  return promise
    .then(response => {
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title: 'Download solicitado. Acompanhe em "Downloads" no topo da tela.',
          icon: 'fa-solid fa-circle-check',
          variant: 'success',
        },
      })
      return response
    })
    .catch(err => {
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title: 'Erro ao solicitar a baixa em lote.',
          icon: 'fa-solid fa-circle-exclamation',
          variant: 'danger',
        },
      })
      throw err
    })
}
